// utils/permissions.js

export const getPermissions = (menu = [], parentName = "", childName = "") => {
    if (!menu.length || !parentName) return null;
  
    const parentItem = menu.find((item) => item.name === parentName);
    if (!parentItem) return null;
  
    if (childName) {
      const subItem = parentItem.sub_menus?.find(
        (sub) => sub.name?.toLowerCase() === childName.toLowerCase()
      );
      return subItem?.permissions || null;
    }
  
    return parentItem.permissions || null;
  };
  